import api from "./api";

// Fixar/desfixar chat
export const pinChat = (chatId, isPinned) => {
  return api.post(`/chats/${chatId}/pin`, { isPinned: Boolean(isPinned) });
};

// Silenciar/dessilenciar chat
export const muteChat = (chatId, isMuted, mutedUntil = null) => {
  return api.post(`/chats/${chatId}/mute`, { 
    isMuted: Boolean(isMuted), 
    mutedUntil 
  });
};

// Arquivar/desarquivar chat
export const archiveChat = (chatId, isArchived) => {
  return api.post(`/chats/${chatId}/archive`, { isArchived: Boolean(isArchived) });
};

// Marcar chat como lido
export const markChatAsRead = (chatId) => {
  return api.put(`/chats/${chatId}/read`);
};
